"use client";

import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "next/navigation";
import Image from "next/image";
import React from "react";

import styles from "./reward.module.scss";
import services from "@/store/services";
import Icons from "@/assets/icons";

const RewardCard = (props) => {
  const user = useSelector((state) => state.user.users);
  const points = useSelector((state) => state.points);
  const { image, title, redeemPoints, _id } = props;
  const router = useRouter();
  const dispatch = useDispatch();

  const handleClick = () => {
    if (!user?.email) {
      dispatch(services.toggleSigninModal());
      return;
    }
    if (points.totalEngagementScore / 60 < redeemPoints) {
      dispatch(
        services.warningAlert(
          `You don't have enough points to redeem this reward.`
        )
      );
      return;
    }
    const progress = Math.floor((user?.profileCpStatus?.length / 7) * 100);
    if (progress > 60) {
      router.push(`/rewards/redeem?rewardId=${_id}`);
    } else dispatch(services.toggleRedeemModal());
  };

  return (
    <figure className={styles.prizeCard} onClick={handleClick}>
      <div className={styles.image}>
        <Image src={image} alt={title} width={500} height={500} />
      </div>

      <div className={styles.text}>
        <h2>{title}</h2>
        <div className={styles.points}>
          <h2>{redeemPoints} </h2>
          <Image
            src={Icons.WatchPoints}
            alt="cipher-point"
            width={25}
            height={25}
          />
        </div>
      </div>
    </figure>
  );
};

export default RewardCard;
